import {
  FilterMode,
  AiSearchResponseCreateMutationVariables,
  AiSearchResponse_OrderBy,
  AiSearchResponse,
  SortOrder,
  AiSearchResponse_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const aiSearchResponseService = {
  createOne: buildCreateOne(
    (
        aiSearchResponseCreateVariables: AiSearchResponseCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.aiSearchResponseCreate(
          aiSearchResponseCreateVariables
        );
        return result.aiSearchResponseCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.aiSearchResponseOne({ id });
    return result.aiSearchResponseOne as AiSearchResponse;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AiSearchResponse_OrderBy[] | null = null,
    filter: AiSearchResponse_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AiSearchResponse_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.aiSearchResponseListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.aiSearchResponseListWithOffset
    ) as AiSearchResponse[];
    return { list, orderBy };
  },
};
